import React, {useContext, useState, useEffect, useReducer} from 'react';
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import {AuthContext} from '../context/AuthContext'

const Accepted = (props) => {

    const {userInfo} = useContext(AuthContext);
    const {data} = useApi( {url: '/Registration/GetScrutinyApplications?status=Accepted', method: 'get' });
    const {data: scrutinyOfficers} = useApi( {url: '/Registration/GetScrutinyOfficers', method: 'get' });

  return (
    <>

<div className="content">
    <div className="header">
        <label className="title"> Registered Students </label>
    </div>
    <p className='text-primary'>***Only these students will be appeared in Annual Examination to be held in 1st January-2025</p>


    <p className='text-danger'>***Documents of your institutes are checked by following Scrutiny Officers. Contact them for clearance of objections (if any) and issuance of registration numbers:</p>
    <ul className='text-danger'>
        {!scrutinyOfficers ? (<></>) : (scrutinyOfficers.map((officer, idx) => {
                return (
                    <>        
                        <li>{officer.fullName} ({officer.mobileNo})</li>
                    </>
                )
        }))}
    </ul>

    {!data ? (<Loader />) : (

    
                                <div className="body">
                                    <div className="animate-bottom">
                                                    {data.map((category, index) => {
                                                        return (
                                                            <div className="table-responsive" > 
                                                            <table className='table table-striped table-hover table-bordered caption-top'>
                                                                <caption >
                                                                    <span key={index}> {category.name} </span>
                                                                </caption>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Session</th>
                                                                        <th>Registration No.</th>
                                                                        <th>Category</th>
                                                                        <th>Student Name</th>
                                                                        <th>Father Name</th>
                                                                    </tr>
                                                                </thead>
                                                                
                                                                <tbody>

                                                                {category.students.map((student, i) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={student.studentID}>
                                                                                <td>{student.session}</td>
                                                                                <td>{student.registrationNo}</td>
                                                                                <td>{student.category}</td>
                                                                                <td>{student.studentName}</td>
                                                                                <td>{student.fatherName}</td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                        </table>
                                                        </div>
                                                        );

                                                    })
                                                    }

                                    </div>


                                    
                                </div>
        )
    }
                                </div>

    </>
  );

};

export default Accepted;